export default __webpack_public_path__ + "static/media/18.785660c8.jpg";